import { Link } from 'react-router-dom';
import { DisplayedIn, Offer, YSH_GTM_EVENTS } from '../types/types';
import OfferAction from './OfferAction';
import { IMAGE_BASE_URL } from '../constants/config';
import CouponsUsedCount from './CouponsUsedCount';
import OfferDiscountLabelContent from './OfferDiscountLabelContent';
import ExpirationInfo from './ExpirationInfo';
import useDynamicParamsLink from '../hooks/useDynamicParamsLink';
import { isUserAdvantageEnabled } from '../utils/auth.ts';
import clsx from 'clsx';
import { pushToAnalytics } from '../utils/analytics.ts';
import Clover from '../assets/images/icons/offer/detelina.png';
import OfferAvailableSoon from './OfferAvailableSoon.tsx';
import '../scss/offer-wide.scss';

interface Props {
  offer: Offer;
  isUserLoggedIn?: boolean;
  imgLoadingType?: 'lazy' | 'eager';
  imgFetchPriority?: 'high' | 'low';
  displayedIn: DisplayedIn;
}

const OfferDisplayWide: React.FC<Props> = ({
  offer,
  isUserLoggedIn,
  imgLoadingType,
  imgFetchPriority,
  displayedIn
}) => {
  const displayCouponExpiration = Boolean(isUserLoggedIn && offer.code);
  const showDiscountLabel = Boolean(offer.discount_value && offer.original_price);
  const showSpecialLabel = Boolean(offer.label_text && offer.label_color);
  const offerLink = useDynamicParamsLink('offerId', offer.id);
  const isAdvantage = Boolean(offer.is_advantage);
  const isUserAdvantage = isUserAdvantageEnabled();
  const isComingSoon = Boolean(offer.coming_soon);

  const handleDownloadAsAdvantageClick = () => {
    const placement = 'Homepage - Yettel_sve';

    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.YSH_TAKE_YETTEL_ALL,
      placement,
      data: {
        coupon_details: {
          coupon_list_id: placement,
          coupon_list_name: placement
        }
      }
    });
  };

  if (isComingSoon) {
    return <OfferAvailableSoon offer={offer} wide={true} />
  }

  return (
    <Link to={offerLink} className={clsx(isAdvantage && 'advantage-offer', 'offer-wide mb-2')}>
      <img
        alt={`${offer.partner_name} - ${offer.name}`}
        className="offer-wide__image"
        src={`${IMAGE_BASE_URL}/${offer.image0}`}
        loading={imgLoadingType}
        fetch-priority={imgFetchPriority}
      />
      {isAdvantage && (
        <div className="advantage-offer__icon">
          <img src={Clover} width={25} />
        </div>
      )}
      {showDiscountLabel && (
        <div className="offer-wide__discount-label">
          <OfferDiscountLabelContent
            originalPrice={offer.original_price as number}
            discountedPrice={offer.discount_value as number}
          />
        </div>
      )}

      {showSpecialLabel && (
        <div className={`offer-wide__special-label offer-wide__special-label--${offer.label_color}`}>
          {offer.label_text}
        </div>
      )}

      <section className="ps-2 pe-2 pb-2 offer-wide__content">
        <h3 className="offer-wide__partner font-yettel-bold fz-16 mt-2 mb-2">{offer.partner_name}</h3>
        <h4 className="offer-wide__name mb-3 font-yettel">{offer.name}</h4>

        <OfferAction offer={offer} isUserLoggedIn={Boolean(isUserLoggedIn)} displayedIn={displayedIn} />

        <section className="d-flex offer__info">
          <ExpirationInfo
            offer={offer}
            isCentered={true}
            lookForExpirationOf={displayCouponExpiration ? 'coupon' : 'offer'}
          />
          {Boolean(offer.used_code_count) && <CouponsUsedCount usedCount={offer.used_code_count} />}
        </section>
      </section>
      {isAdvantage && !isUserAdvantage && (
        <div onClick={() => handleDownloadAsAdvantageClick()} className="advantage-offer__cta">
          <p>
            Preuzmi uz
            <br /> Y. Sve mobile+bank
          </p>
        </div>
      )}
    </Link>
  );
};

export default OfferDisplayWide;
